module.exports = __webpack_public_path__ + "static/media/grove-iros26.1c38bacf.png";